// extracted by mini-css-extract-plugin
module.exports =  {"tag":"_93444fe79c--tag--Gj4bC","tag_content":"_93444fe79c--tag_content--EpMVE","tag_close":"_93444fe79c--tag_close--NT5sL"};